import React from "react";
import * as Mui from "@mui/material";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";

export const CustomToggleButton = ({
  alignment,
  handleChange,
  buttons,
  themes,
  shouldResize,
}) => {
  return (
    <Mui.Grid
      container
      sx={{
        flexDirection: "row",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Mui.Grid xs={4.4}>
        <Mui.Box
          sx={{
            display: "flex",
            alignItems: "center",
            width:
              buttons.length === 2
                ? shouldResize
                  ? 300
                  : 500
                : buttons.length === 3
                ? 400
                : 500,
            height: 47,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <ToggleButtonGroup
            value={alignment}
            exclusive
            onChange={handleChange}
            sx={{
              display: "flex",
              width: "100%",
              height: "100%",
              position: "absolute",
              borderRadius: shouldResize ? "10px" : "30px",
              backgroundColor: themes.lightBrown,
            }}
          >
            {buttons.map((btn, index) => (
              <ToggleButton
                key={btn.value}
                value={btn.value}
                onClick={btn.onClick}
                sx={{
                  flex: 1,
                  textTransform: "capitalize",
                  fontSize: 18,
                  fontWeight: 600,
                  border: "none",
                  borderRadius: shouldResize ? "10px" : "30px",
                  color:
                    alignment === btn.value
                      ? themes.whiteColor
                      : themes.headLine,
                  backgroundColor:
                    alignment === btn.value
                      ? themes.headLine
                      : themes.lightBrown,
                  "&.Mui-selected": {
                    backgroundColor: themes.headLine,
                    color: themes.whiteColor,
                    "&:hover": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                    },
                    borderRadius: shouldResize ? "10px" : "30px",
                    "&.Mui-selected": {
                      borderRadius: shouldResize ? "10px" : "30px",
                    },
                  },
                  "&:hover": {
                    backgroundColor:
                      alignment === btn.value
                        ? themes.headLine
                        : themes.lightBrown,
                    color:
                      alignment === btn.value
                        ? themes.whiteColor
                        : themes.headLine,
                  },
                  "&:focus": {
                    backgroundColor:
                      alignment === btn.value
                        ? themes.headLine
                        : themes.lightBrown,
                    color:
                      alignment === btn.value
                        ? themes.whiteColor
                        : themes.headLine,
                  },
                }}
              >
                {btn.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Mui.Box>
      </Mui.Grid>
    </Mui.Grid>
  );
};
